import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getDirectory,updateDirectory } from "./ParticipantDirectoryAPI";
import { ParticipantDirectoryInterface } from "../../app/consts";
import { RootState } from "../../app/store";

export interface directoryState{
    directory:ParticipantDirectoryInterface[],
}

const initialState:directoryState = {
    directory:[]
}

export const getDirectoryAsync = createAsyncThunk(
  'Workout/getDirectory',
  async (_, { rejectWithValue }) => {
    try {
      return await getDirectory();
    } catch (error: any) {
      return rejectWithValue(error.response?.data || { msg: 'שגיאה בטעינת המאגר' });
    }
  }
);

export const updateDirectoryAsync = createAsyncThunk(
  'Workout/updateDirectory',
  async (data:ParticipantDirectoryInterface, { rejectWithValue }) => {
    try {
      return await updateDirectory(data);
    } catch (error: any) {
      return rejectWithValue(error.response?.data || { msg: 'שגיאה בעדכון המשתמש' });
    }
  }
);


export const ParticipantDirectorySlice = createSlice({
  name: 'ParticipantDirectory',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
    .addCase(getDirectoryAsync.fulfilled,(state,action)=>{
      state.directory = action.payload
    })
    .addCase(updateDirectoryAsync.fulfilled,(state,action)=>{
      getDirectoryAsync()
    })
  },
})

export const selectDirectory = (state: RootState) => state.ParticipantDirectory.directory;

export default ParticipantDirectorySlice.reducer;